export default {
  name: 'cartTotal',
  component() {
    return {
      get total() { return this.$store.cart.formatPrice(this.$store.cart.totalPrice); },
      get subtotal() { return this.$store.cart.formatPrice(this.$store.cart.subtotalPrice); }
    };
  }
};